import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomCircleCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";
import { checkFormatAllow, getUUID } from "common/util";
import { PaymentMethodTypeDropdownItem } from "./PurchaseData";


interface PurchaseAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

PurchaseAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}


interface ProductOptionData {
    product_option_id: string;
    product_option_type_code: string;
    option_count: number;
    option_price: number;
}

interface ProductData {
    product_id: string;
    product_name: string;
    product_type_code: string;
    base_price: number;
}

interface LicenseData {
    license_id: string;
    license_number: string;
    license_name: string;
    product: ProductData
}

export default function PurchaseAdd(props:PurchaseAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [userId, setUserId] = useState("");
    const [paymentMethodType, setPaymentMethodType] = useState("CRDCARD");
    const [paymentName, setPaymentName] = useState("");
    const [productId, setProductId] = useState("");
    const [productType, setProductType] = useState("RDS");
    const [basePrice, setBasePrice] = useState("0");
    const [deviceCount, setDeviceCount] = useState("1");
    const [deviceOptionPrice, setDeviceOptionPrice] = useState("0");
    const [purchaseSource, setPurchaseSource] = useState("FornaX Cloud");

    const [multiUserCount, setMultiUserCount] = useState("1");
    const [multiUserOptionPrice, setMultiUserOptionPrice] = useState("0");
    const [multiMonitorCount, setMultiMonitorCount] = useState("1");
    const [multiMonitorOptionPrice, setMultiMonitorOptionPrice] = useState("0");
    const [upgradeSupportYears, setUpgradeSupportYears] = useState("1");
    const [upgradeSupportOptionPrice, setUpgradeSupportOptionPrice] = useState("0");
    const [useExpireDates, setUseExpireDates] = useState("30")
    const [useExpireOptionPrice, setUseExpireOptionPrice] = useState("0")
    const [acessibilityCount, setAcessibilityCount] = useState("1");
    const [acessibilityOptionPrice, setAcessibilityOptionPrice] = useState("0");

    const [newLicenseYn, setNewLicenseYn] = useState(true);
    const [deviceOptionYn, setDeviceOptionYn] = useState(true);
    const [multiUserOptionYn, setMultiUserOptionYn] = useState(true);
    const [multiMonitorOptionYn, setMultiMonitorOptionYn] = useState(true);
    const [upgradeSupportOptionYn, setUpgradeSupportOptionYn] = useState(true);
    const [useExpireOptionYn, setUseExpireOptionYn] = useState(false);
    const [acessibilityOptionYn, setAcessibilityOptionYn] = useState(true);
    const [licenseId, setLicenseId] = useState("");
    
    const [paymentNameWarnYn, setPaymentNameWarnYn] = useState(false);
    const [purchaseSourceWarnYn, setPurchaseSourceWarnYn] = useState(false);
    const [basePriceWarnYn, setBasePriceWarnYn] = useState(false);
    const [deviceCountWarnYn, setDeviceCountWarnYn] = useState(false);
    const [multiUserCountWarnYn, setMultiUserCountWarnYn] = useState(false);
    const [multiMonitorCountWarnYn, setMultiMonitorCountWarnYn] = useState(false);
    const [upgradeSupportYearsWarnYn, setUpgradeSupportYearsWarnYn] = useState(false);
    const [useExpireDatesWarnYn, setUseExpireDatesWarnYn] = useState(false);
    const [acessibilityCountWarnYn, setAcessibilityCountWarnYn] = useState(false);
    const [deviceOptionPriceWarnYn, setDeviceOptionPriceWarnYn] = useState(false);
    const [multiUserOptionPriceWarnYn, setMultiUserOptionPriceWarnYn] = useState(false);
    const [multiMonitorOptionPriceWarnYn, setMultiMonitorOptionPriceWarnYn] = useState(false);
    const [upgradeSupportOptionPriceWarnYn, setUpgradeSupportOptionPriceWarnYn] = useState(false);
    const [useExpireOptionPriceWarnYn, setUseExpireOptionPriceWarnYn] = useState(false);
    const [acessibilityOptionPriceWarnYn, setAcessibilityOptionPriceWarnYn] = useState(false);

    const [productList, setProductList] = useState<DropdownType[]>([ {value: "", label: t("EMPTY_TEXT")} ]);
    const [productDataList, setProductDataList] = useState<ProductData[]>([]);
    const [userList, setUserList] = useState<DropdownType[]>([ {value: "", label: t("EMPTY_TEXT")} ]);
    const [licenseList, setLicenseList] = useState<DropdownType[]>([ {value: "", label: t("EMPTY_TEXT")} ]);
    const [licenseDataList, setLicenseDataList] = useState<LicenseData[]>([]);
    const [rdsDeviceOption, setRdsDeviceOption] = useState<ProductOptionData>();
    const [rdsMultiUserOption, setRdsMultiUserOption] = useState<ProductOptionData>();
    const [rdsMultiMonitorOption, setRdsMultiMonitorOption] = useState<ProductOptionData>();
    const [rdsUpgradeSupportOption, setRdsUpgradeSupportOption] = useState<ProductOptionData>();
    const [rdsUseExpireOption, setRdsUseExpireOption] = useState<ProductOptionData>();
    const [rdsAcessibilityOption, setRdsAcessibilityOption] = useState<ProductOptionData>();
    const [purchaseTargetType, setPurchaseTargetType] = useState("PRD");
    const [productChangeYn, setProductChangeYn] = useState(false);
    const [licenseProductName, setLicenseProductName] = useState("");

    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadProductList();
            loadUserList();
        }
    }, [stepIndex]);


    useEffect(() => {
        if(productId) {
            loadProductOptionList();
            if(!licenseId) {
                for(let productData of productDataList) {
                    if(productData.product_id === productId) {
                        setBasePrice(productData.base_price + "");
                        setLicenseProductName(productData.product_name + " " + productData.product_type_code);
                        setPaymentName("FornaX Cloud " + productData.product_name + " " + productData.product_type_code);
                    }
                }
            }
        }
    }, [productId])


    useEffect(() => {
        if(productChangeYn) {
            setProductChangeYn(false);
        }
    }, [productChangeYn])

    useEffect(() => {
        if(licenseId) {
            for(let licenseData of licenseDataList) {
                if(licenseData.license_id === licenseId) {
                    setProductId(licenseData.product.product_id);
                    setLicenseProductName(licenseData.product.product_name + " " + licenseData.product.product_type_code);
                    setPaymentName("FornaX Cloud " + licenseData.product.product_name + " " + licenseData.product.product_type_code);
                    setBasePrice("0");
                }
            }
        }
    }, [licenseId])

    useEffect(() => {
        if(newLicenseYn === true) {
            setLicenseDataList([]);
            setLicenseList([]);
            setLicenseProductName("");
            setPaymentName("");
            setBasePrice("0");
            setProductId("");
        } else {
            setLicenseProductName("");
            setPaymentName("");
            setBasePrice("0");
            setProductId("");
        }
    }, [newLicenseYn])

    useEffect(() => {
        if(userId && newLicenseYn === false) {
            loadLicenseList();
        }
    }, [userId, newLicenseYn])

    
    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkPurchaseData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(newLicenseYn === true) {
            if(upgradeSupportOptionYn == useExpireOptionYn) {
                setUseExpireOptionYn(!upgradeSupportOptionYn);
            }
        }
    }, [upgradeSupportOptionYn])

    useEffect(() => {
        if(newLicenseYn === true) {
            if(useExpireOptionYn == upgradeSupportOptionYn) {
                setUpgradeSupportOptionYn(!useExpireOptionYn);
            }
        }
    }, [useExpireOptionYn])


    useEffect(() => {
        if(executeAddYn) {
            executeAddPurchase();
        }
    }, [executeAddYn]);

    function loadProductList() {
        requests.get(PLATFORM_URL.PRODUCT, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProductList(response.data.items.map((data)=>{
                    return {value:data.product_id, label:data.product_name + "(" + data.product_type_code + ")"}
                }).filter(v => v !== false));
                setProductDataList(response.data.items);
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadProductOptionList() {
        if(!productId) {
            setRdsDeviceOption(undefined);
            setDeviceOptionPrice("0");
            setDeviceCount("0");
            setRdsMultiUserOption(undefined);
            setMultiUserOptionPrice("0");
            setMultiUserCount("0");
            setRdsMultiMonitorOption(undefined);
            setMultiMonitorOptionPrice("0");
            setMultiMonitorCount("0");
            setRdsUpgradeSupportOption(undefined);
            setUpgradeSupportOptionPrice("0");
            setUpgradeSupportYears("0");
            setRdsUseExpireOption(undefined);
            setUseExpireOptionPrice("0");
            setUseExpireDates("0");
            setRdsAcessibilityOption(undefined);
            setAcessibilityOptionPrice("0");
            setAcessibilityCount("0");
            setProductChangeYn(true);
            return
        }
        requests.get(PLATFORM_URL.PRODUCT + '/' + productId + '/options', {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                for(let option of response.data?.items) {
                    if (option.product_option_type_code === "MTDEV") {
                        setRdsDeviceOption(option);
                        setDeviceOptionPrice(option.option_price + "");
                        setDeviceCount(option.option_count + "");
                    } else if(option.product_option_type_code === "MTUSR") {
                        setRdsMultiUserOption(option);
                        setMultiUserOptionPrice(option.option_price + "");
                        setMultiUserCount(option.option_count + "");
                    } else if(option.product_option_type_code === "MTMON") {
                        setRdsMultiMonitorOption(option);
                        setMultiMonitorOptionPrice(option.option_price + "");
                        setMultiMonitorCount(option.option_count + "");
                    } else if(option.product_option_type_code === "UPSPT") {
                        setRdsUpgradeSupportOption(option);
                        setUpgradeSupportOptionPrice(option.option_price + "");
                        setUpgradeSupportYears(option.option_count + "");
                    } else if(option.product_option_type_code === "EXPDT") {
                        setRdsUseExpireOption(option);
                        setUseExpireOptionPrice(option.option_price + "");
                        setUseExpireDates(option.option_count + "");
                    } else if(option.product_option_type_code === "ACBT") {
                        setRdsAcessibilityOption(option);
                        setAcessibilityOptionPrice(option.option_price + "");
                        setAcessibilityCount(option.option_count + "");
                    }
                }
            }
            setProductChangeYn(true);
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
            setProductChangeYn(true);
        });
    }

    function loadUserList() {
        requests.get(PLATFORM_URL.USERS, {size: 9999})
        .then((response) => {
            if(response.status === 200 && response.data?.items) {
                setUserList(response.data.items.map((data)=>{
                    if(data.user_role_type_code !== "USR") {
                        return false;
                    }
                    if(data.user_status_code !== "ACT") {
                        return false;
                    }
                    return {value:data.user_id, label:data.email}
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadLicenseList() {
        if(!userId) {
            setLicenseList([{value: "", label: t("EMPTY_TEXT")}]);
            return
        }

        requests.get(PLATFORM_URL.LICENSE + "/rds", {size: 9999, user_id: userId})
        .then((response) => {
            if(response.status === 200 && response.data?.items) {
                setLicenseList(response.data.items.map((data)=>{
                    return {value:data.license_id, label:data.license_number + "(" + data.license_name + ")"}
                }).filter(v => v !== false));
                setLicenseDataList(response.data?.items);
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });

    }
    function checkPurchaseData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setPaymentNameWarnYn(false);
        setPurchaseSourceWarnYn(false);
        setBasePriceWarnYn(false);
        setDeviceCountWarnYn(false);
        setMultiUserCountWarnYn(false);
        setMultiMonitorCountWarnYn(false);
        setUpgradeSupportYearsWarnYn(false);
        setUseExpireDatesWarnYn(false);
        setAcessibilityCountWarnYn(false);
        setDeviceOptionPriceWarnYn(false);
        setMultiUserOptionPriceWarnYn(false);
        setMultiMonitorOptionPriceWarnYn(false);
        setUpgradeSupportOptionPriceWarnYn(false);
        setUseExpireOptionPriceWarnYn(false);
        setAcessibilityOptionPriceWarnYn(false);
        
        let message = "";
        let error = false;
        if(!userId) {
            message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }

        if(newLicenseYn === true && (!productId || !basePrice)) {
            if(!basePrice) {
                setBasePriceWarnYn(true);
            }
            message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(newLicenseYn === false && !licenseId) {
            message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }

        if(!paymentName) {
            message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
            if(!paymentName) {
                setPaymentNameWarnYn(true);    
            }
            error = true;
        }

        if(newLicenseYn === true) {
            if(!deviceCount || !multiUserCount || !multiMonitorCount || !acessibilityCount || !upgradeSupportYears || !deviceOptionPrice || !multiUserOptionPrice || !multiMonitorOptionPrice || !acessibilityOptionPrice || (upgradeSupportOptionYn === true && !upgradeSupportOptionPrice) || (useExpireOptionYn === true && !useExpireDates)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                if(!deviceCount) {
                    setDeviceCountWarnYn(true);
                }
                if(!multiUserCount) {
                    setMultiUserCountWarnYn(true);
                }
                if(!multiMonitorCount) {
                    setMultiMonitorCountWarnYn(true);
                }
                if(!upgradeSupportYears) {
                    setUpgradeSupportYearsWarnYn(true);
                }
                if(!acessibilityCount) {
                    setAcessibilityCountWarnYn(true);
                }
                if(!deviceOptionPrice) {
                    setDeviceOptionPriceWarnYn(true);
                }
                if(!multiUserOptionPrice) {
                    setMultiUserOptionPriceWarnYn(true);
                }
                if(!multiMonitorOptionPrice) {
                    setMultiMonitorOptionPriceWarnYn(true);
                }
                if(upgradeSupportOptionYn === true && !upgradeSupportOptionPrice) {
                    setUpgradeSupportOptionPriceWarnYn(true);
                }
                if(useExpireOptionYn === true && !useExpireOptionPrice) {
                    setUseExpireOptionPriceWarnYn(true);
                }
                if(!acessibilityOptionPrice) {
                    setAcessibilityOptionPriceWarnYn(true);
                }
                
                error = true;
            }
            
            if(checkFormatAllow(basePrice, ["number"]) === false || Number(basePrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setBasePriceWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(deviceCount, ["number"]) === false || Number(deviceCount) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setDeviceCountWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(multiUserCount, ["number"]) === false || Number(multiUserCount) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiUserCountWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(multiMonitorCount, ["number"]) === false || Number(multiMonitorCount) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiMonitorCountWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(acessibilityCount, ["number"]) === false || Number(acessibilityCount) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setAcessibilityCountWarnYn(true);
                error = true;
            }

            if(upgradeSupportOptionYn === true && (checkFormatAllow(upgradeSupportYears, ["number"]) === false || Number(upgradeSupportYears) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUpgradeSupportYearsWarnYn(true);
                error = true;
            }

            if(useExpireOptionYn === true && (checkFormatAllow(useExpireDates, ["number"]) === false || Number(useExpireDates) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUseExpireDatesWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(deviceOptionPrice, ["number"]) === false || Number(deviceOptionPrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setDeviceOptionPriceWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(multiUserOptionPrice, ["number"]) === false || Number(multiUserOptionPrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiUserOptionPriceWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(multiMonitorOptionPrice, ["number"]) === false || Number(multiMonitorOptionPrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiMonitorOptionPriceWarnYn(true);
                error = true;
            }

            if(checkFormatAllow(upgradeSupportOptionPrice, ["number"]) === false || Number(upgradeSupportOptionPrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUpgradeSupportOptionPriceWarnYn(true);
                error = true;
            }
            if(checkFormatAllow(acessibilityOptionPrice, ["number"]) === false || Number(acessibilityOptionPrice) < 0) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setAcessibilityOptionPriceWarnYn(true);
                error = true;
            }
        } else {
            if(deviceOptionYn === true && (!deviceCount || checkFormatAllow(deviceCount, ["number"]) === false || Number(deviceCount) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setDeviceCountWarnYn(true);
                error = true;
            }
            if(deviceOptionYn === true && (!deviceOptionPrice || checkFormatAllow(deviceOptionPrice, ["number"]) === false || Number(deviceOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setDeviceOptionPriceWarnYn(true);
                error = true;
            }
            if(multiUserOptionYn === true && (!multiUserCount || checkFormatAllow(multiUserCount, ["number"]) === false || Number(multiUserCount) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiUserCountWarnYn(true);
                error = true;
            }
            if(multiUserOptionYn === true && (!multiUserOptionPrice || checkFormatAllow(multiUserOptionPrice, ["number"]) === false || Number(multiUserOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiUserOptionPriceWarnYn(true);
                error = true;
            }

            if(multiMonitorOptionYn === true && (!multiMonitorCount || checkFormatAllow(multiMonitorCount, ["number"]) === false || Number(multiMonitorCount) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiMonitorCountWarnYn(true);
                error = true;
            }
            if(multiMonitorOptionYn === true && (!multiMonitorOptionPrice || checkFormatAllow(multiMonitorOptionPrice, ["number"]) === false || Number(multiMonitorOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setMultiMonitorOptionPriceWarnYn(true);
                error = true;
            }

            if(upgradeSupportOptionYn === true && (!upgradeSupportYears || checkFormatAllow(upgradeSupportYears, ["number"]) === false || Number(upgradeSupportYears) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUpgradeSupportYearsWarnYn(true);
                error = true;
            }
            if(upgradeSupportOptionYn === true && (!upgradeSupportOptionPrice || checkFormatAllow(upgradeSupportOptionPrice, ["number"]) === false || Number(upgradeSupportOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUpgradeSupportOptionPriceWarnYn(true);
                error = true;
            }
            if(useExpireOptionYn === true && (!useExpireDates || checkFormatAllow(useExpireDates, ["number"]) === false || Number(useExpireDates) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUseExpireDatesWarnYn(true);
                error = true;
            }
            if(useExpireOptionYn === true && (!useExpireOptionPrice || checkFormatAllow(useExpireOptionPrice, ["number"]) === false || Number(useExpireOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setUseExpireOptionPriceWarnYn(true);
                error = true;
            }
            if(acessibilityOptionYn === true && (!acessibilityCount || checkFormatAllow(acessibilityCount, ["number"]) === false || Number(acessibilityCount) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setAcessibilityCountWarnYn(true);
                error = true;
            }
            if(acessibilityOptionYn === true && (!acessibilityOptionPrice || checkFormatAllow(acessibilityOptionPrice, ["number"]) === false || Number(acessibilityOptionPrice) < 0)) {
                message = t("MESSAGE_SERVICE_PURCHASE_INFO_ENTER_ERROR_MESSAGE")
                setAcessibilityOptionPriceWarnYn(true);
                error = true;
            }
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function executeAddPurchase() {
        const addPackageData = {
            user: {
                user_id: userId
            },
            purchase: {
                payment_order_id: getUUID(),
                payment_name: paymentName,
                payment_key: " ",
                payment_method_code: paymentMethodType,
                purchase_source: purchaseSource || "FornaX Cloud"
            }
        }

        if (newLicenseYn === true) {
            addPackageData['product'] = {
                product_id: productId,
                base_price: basePrice
            }
        } else {
            addPackageData['license'] = {
                license_id: licenseId
            }
        }

        if (productType === 'RDS') {
            if(!rdsDeviceOption || !rdsMultiUserOption || !rdsMultiMonitorOption || !rdsAcessibilityOption || !rdsUpgradeSupportOption || !rdsUseExpireOption) {
                executeResult({successYn: false}, false, t("MESSAGE_SERVICE_PURCHASE_ADD_PRODUCT_OPTION_INVALID_MESSAGE"));
            }

            addPackageData['product_options'] = []
            if(newLicenseYn === true || deviceOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsDeviceOption?.product_option_id,
                    option_price: Number(deviceOptionPrice),
                    option_count: Number(deviceCount)
                })
            }
            if(newLicenseYn === true || multiUserOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsMultiUserOption?.product_option_id,
                    option_price: Number(multiUserOptionPrice),
                    option_count: Number(multiUserCount)
                })
            }
            if(newLicenseYn === true || multiMonitorOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsMultiMonitorOption?.product_option_id,
                    option_price: Number(multiMonitorOptionPrice),
                    option_count: Number(multiMonitorCount)
                })
            }
            if(upgradeSupportOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsUpgradeSupportOption?.product_option_id,
                    option_price: Number(upgradeSupportOptionPrice),
                    option_count: Number(upgradeSupportYears)
                })
            }
            if(useExpireOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsUseExpireOption?.product_option_id,
                    option_price: Number(useExpireOptionPrice),
                    option_count: Number(useExpireDates)
                })
            }
            if(newLicenseYn === true || acessibilityOptionYn === true) {
                addPackageData['product_options'].push({
                    product_option_id: rdsAcessibilityOption?.product_option_id,
                    option_price: Number(acessibilityOptionPrice),
                    option_count: Number(acessibilityCount)
                })
            }
        }
        
        requests.post(PLATFORM_URL.PURCHASE, addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    
    function selectTargetButton(id, type) {
        if(id === "TargetType") {
            setPurchaseTargetType(type);
            if(type === "PRD") {
                setNewLicenseYn(true);
            } else if(type === "LICS") {
                setNewLicenseYn(false);
            }
        }
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("SERVICE_PRODUCT_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ACCOUNT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={1} 
                                width={300} height={36} 
                                items={userList}
                                setValue={setUserId} 
                                disable={false}
                                defaultvalue={{value: "", label: t("EMPTY_TEXT")}}
                            />
                        </View>
                        {
                            userId ?
                            <Fragment>
                                <View style={style.rowContainer}>
                                    <CustomText text={t("SERVICE_PURCAHSE_TARGET_SELECTION_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomRadioBtn 
                                        id={"TargetType"} 
                                        type={"PRD"} 
                                        size={18} 
                                        checked={purchaseTargetType === "PRD" ? true : false}
                                        selectCb={selectTargetButton}
                                        label={"새 라이센스 추가"}
                                        labelStyle={labelStyle}
                                    />
                                    <View style={{width: 44}}/>
                                    <CustomRadioBtn 
                                        id={"TargetType"} 
                                        type={"LICS"} 
                                        size={19} 
                                        checked={purchaseTargetType === "LICS" ? true : false}
                                        selectCb={selectTargetButton} 
                                        label={"기존 라이센스에 옵션 추가"}
                                        labelStyle={labelStyle}
                                    />
                                </View>
                                {
                                    newLicenseYn === false
                                    ?
                                    <Fragment>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_PURCHASE_LICENSE_SELECTION_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomDropDown 
                                                key={2} 
                                                width={300} height={36} 
                                                items={licenseList}
                                                setValue={setLicenseId} 
                                                disable={false}
                                                defaultvalue={{value: "", label: t("EMPTY_TEXT")}}
                                            />
                                        </View>
                                        {
                                            productId && licenseProductName
                                            ?
                                            <View style={style.rowContainer}>
                                                <Text style={style.columnText}>
                                                    {t("SERVICE_PURCHASE_PRODUCT_SELECTION_TEXT")}
                                                </Text>
                                                <Text style={{...style.dataText, color: "#7066f1"}}>
                                                    {licenseProductName}
                                                </Text>
                                            </View>
                                            : null
                                        }
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_PURCHASE_PRODUCT_SELECTION_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomDropDown 
                                                key={3} 
                                                width={300} height={36} 
                                                items={productList}
                                                setValue={setProductId} 
                                                disable={false}
                                                defaultvalue={{value: "", label: t("EMPTY_TEXT")}}
                                            />
                                        </View>
                                        {
                                            productId && productChangeYn === false
                                            ?<View style={style.rowContainer}>
                                                <CustomText text={t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                                <CustomTextInput 
                                                    key={115} 
                                                    width={152} height={36} 
                                                    value={basePrice}
                                                    type={"number"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{setBasePrice(v)}}
                                                    warnYn={basePriceWarnYn} 
                                                    placeHolderText={t("0")}
                                                />
                                            </View>
                                            : null
                                        }
                                    </Fragment>
                                }
                                {
                                    productId && productChangeYn === false?
                                    <View style={style.rowContainer}>
                                        <CustomText text={t("SERVICE_PURCHASE_SOURCE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                        <CustomTextInput 
                                            key={1135} 
                                            width={300} height={36} 
                                            value={purchaseSource}
                                            type={"text"} 
                                            activeYn={true} 
                                            inputCb={(v)=>{setPurchaseSource(v)}}
                                            warnYn={purchaseSourceWarnYn} 
                                            placeHolderText={t("0")}
                                        />
                                    </View>
                                    : null
                                }
                                {
                                    productId && productChangeYn === false?
                                    <Fragment>
                                        <View style={style.rowDivContainer}/>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_DEVICE_COUNT_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="DeviceCountYn"
                                                key={4} 
                                                checked={newLicenseYn === true || deviceOptionYn === true}
                                                setCheckBoxStatus={(v) => {setDeviceOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_OPTION_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={5} 
                                                width={152} height={36} 
                                                value={deviceCount}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || deviceOptionYn === true} 
                                                inputCb={(v)=>{setDeviceCount(v)}}
                                                warnYn={deviceCountWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={6} 
                                                width={152} height={36} 
                                                value={deviceOptionPrice}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || deviceOptionYn === true} 
                                                inputCb={(v)=>{setDeviceOptionPrice(v)}}
                                                warnYn={deviceOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_USER_COUNT_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="MultiUserYn"
                                                key={7} 
                                                checked={newLicenseYn === true || multiUserOptionYn === true}
                                                setCheckBoxStatus={(v) => {setMultiUserOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_OPTION_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={8} 
                                                width={152} height={36} 
                                                value={multiUserCount}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || multiUserOptionYn === true} 
                                                inputCb={(v)=>{setMultiUserCount(v)}} 
                                                warnYn={multiUserCountWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={9} 
                                                width={152} height={36} 
                                                value={multiUserOptionPrice}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || multiUserOptionYn === true} 
                                                inputCb={(v)=>{setMultiUserOptionPrice(v)}}
                                                warnYn={multiUserOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_MONITOR_COUNT_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="MultiMonitorYn"
                                                key={10} 
                                                checked={newLicenseYn === true || multiMonitorOptionYn === true}
                                                setCheckBoxStatus={(v) => {setMultiMonitorOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_OPTION_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={11} 
                                                width={152} height={36} 
                                                value={multiMonitorCount}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || multiMonitorOptionYn === true}
                                                inputCb={(v)=>{setMultiMonitorCount(v)}} 
                                                warnYn={multiMonitorCountWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={12} 
                                                width={152} height={36} 
                                                value={multiMonitorOptionPrice}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || multiMonitorOptionYn === true} 
                                                inputCb={(v)=>{setMultiMonitorOptionPrice(v)}}
                                                warnYn={multiMonitorOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_ACESSIBILITY_COUNT_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="AcessibilityYn"
                                                key={110} 
                                                checked={newLicenseYn === true || acessibilityOptionYn === true}
                                                setCheckBoxStatus={(v) => {setAcessibilityOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_OPTION_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={111} 
                                                width={152} height={36} 
                                                value={acessibilityCount}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || acessibilityOptionYn === true}
                                                inputCb={(v)=>{setAcessibilityCount(v)}} 
                                                warnYn={acessibilityCountWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={112} 
                                                width={152} height={36} 
                                                value={acessibilityOptionPrice}
                                                type={"number"} 
                                                activeYn={newLicenseYn === true || acessibilityOptionYn === true} 
                                                inputCb={(v)=>{setAcessibilityOptionPrice(v)}}
                                                warnYn={acessibilityOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_UPGRADE_SUPPORT_YEARS_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="UpgradeSupportYn"
                                                key={13} 
                                                checked={upgradeSupportOptionYn === true}
                                                setCheckBoxStatus={(v) => {setUpgradeSupportOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_YEAR_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={14} 
                                                width={152} height={36} 
                                                value={upgradeSupportYears}
                                                type={"number"} 
                                                activeYn={upgradeSupportOptionYn === true} 
                                                inputCb={(v)=>{setUpgradeSupportYears(v)}} 
                                                warnYn={upgradeSupportYearsWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={15} 
                                                width={152} height={36} 
                                                value={upgradeSupportOptionPrice}
                                                type={"number"} 
                                                activeYn={upgradeSupportOptionYn === true} 
                                                inputCb={(v)=>{setUpgradeSupportOptionPrice(v)}}
                                                warnYn={upgradeSupportOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("SERVICE_LICENSE_EXPIRE_DATE_TEXT")} fontStyle={style.columnText} asterisk={newLicenseYn}/>
                                            <Text style={{...style.columnText, width: 30}}>
                                                {t("SERVICE_PURCHASE_OPTION_YN_TEXT")}
                                            </Text>
                                            <CustomCircleCheckBox 
                                                id="UseExpireYn"
                                                key={213} 
                                                checked={useExpireOptionYn === true}
                                                setCheckBoxStatus={(v) => {setUseExpireOptionYn(v)}}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 40}}>
                                                {t("SERVICE_PURCHASE_DATE_COUNT_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={214} 
                                                width={152} height={36} 
                                                value={useExpireDates}
                                                type={"number"} 
                                                activeYn={useExpireOptionYn === true} 
                                                inputCb={(v)=>{setUseExpireDates(v)}} 
                                                warnYn={useExpireDatesWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                            <View style={{width: 40}}></View>
                                            <Text style={{...style.columnText, width: 60}}>
                                                {t("SERVICE_PURCHASE_OPTION_PRICE_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={215} 
                                                width={152} height={36} 
                                                value={useExpireOptionPrice}
                                                type={"number"} 
                                                activeYn={useExpireOptionYn === true} 
                                                inputCb={(v)=>{setUseExpireOptionPrice(v)}}
                                                warnYn={useExpireOptionPriceWarnYn} 
                                                placeHolderText={t("0")}
                                            />
                                        </View>
                                        {
                                            newLicenseYn === false
                                            ?<Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                                                {t("DESCRIBE_SERVICE_PURCAHSE_OPTION_SELECT")}
                                            </Text>
                                            : null
                                        }
                                    </Fragment>
                                    :null
                                }
                            </Fragment>
                            : null
                        }
                    </View>
                </View>
                : null
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}